<template>
  <section class="section">
    <div class="container has-text-centered">
      <p class="title">{{ t('meclee-ui.landings.business.cta.title') }}
      </p>
      <Button class="action" @click="isModalActiveModel = true">{{ t('meclee-ui.landings.business.cta.button') }}</Button>
    </div>
  </section>
</template>

<script lang="ts" setup>
import Button from "../Button.vue";
const {t} = useI18n();

const emit = defineEmits(['update:isModalActive']);

const isModalActiveModel = computed({
  get() {
    return isModalActive;
  },
  set(value: boolean) {
    emit('update:isModalActive', value);
  }
});
</script>

<style scoped>

</style>
